import React, { useEffect } from 'react';
import {CheckCircle, XCircle} from "lucide-react";
import './Toast.css';
import { useTranslation } from 'react-i18next';

const Toast = ({ message, onClose, error = false }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[9999] animate-fade-in select-none">
            <div
                className={`${error ? 'bg-red-600' : 'bg-[#3c4f58]'} 
                text-white px-6 py-3 rounded-lg shadow-xl 
                flex items-center gap-3 min-w-[300px] justify-center
                border border-white/10`}
            >
                {error ? (
                    <XCircle className="text-white" size={20} />
                ) : (
                    <CheckCircle className="text-white" size={20} />
                )}
                <span className="text-[15px] font-medium">{message}</span>
            </div>
        </div>
    );
};

export default Toast;